import { useTranslation } from "react-i18next";
import { HoverPopover } from "@/components/ui";
import { cn } from "@/lib/utils";

export function LegalIncompleteBadge({ className }: { className?: string }) {
  const { t } = useTranslation("payments");
  const label = t("settlements.payees.legalIncompleteTooltip");

  return (
    <HoverPopover
      content={label}
      placement="below"
    >
      <span
        className={cn(
          "inline-flex h-6 w-6 items-center justify-center rounded-full bg-warning-50 text-xs font-bold text-warning-700 ring-1 ring-inset ring-warning-600/25",
          className,
        )}
        aria-label={label}
        onClick={(event) => event.stopPropagation()}
      >
        !
      </span>
    </HoverPopover>
  );
}
